
import * as type from './types';

export function getRefarralList(data) {
    return {
        type: type.GET_REFARRAL_LIST_REQUESTED,
        data: data,
    }
}